
<template>
  <div style="display:inline;">
    <v-btn large disabled
      v-if="!pollCompleted"
      color="red"
      :loading="lockPdfButton"
    >
      <v-icon>mdi-file-cancel</v-icon>
      {{ $t('individualReport.input_no_participation') }}
    </v-btn>
    <v-btn large
      v-else
      color="primary"
      :loading="lockPdfButton"
      :disabled="disableButton || !evaluatedId"
      @click="runOpenReport"
    >
      <v-icon>mdi-file-pdf</v-icon>
      {{ $t('individualReport.input_generate_report') }}
    </v-btn>
  </div>
</template>

<script>
import Vue from 'vue'

import evaluationService from '../../services/evaluations'

export default Vue.extend({
  name: 'thread-individual-report',
  components: {
    //
  },
  props: {
    pollId: String,
    pollCompleted: Boolean,
    disableButton: Boolean,
    evaluatedId: Number,
    evaluatedName: String
  },
  data () {
    return {
      lockPdfButton: false,
      disableButtonModal: true
    }
  },
  watch: {
    disableButton () {
      this.disableButtonModal = this.disableButton
    }
  },
  methods: {
    runOpenReport () {
      this.$store.dispatch('loading/show')
      this.lockPdfButton = true
      return evaluationService.openReportIndividualOneById(this.pollId, this.evaluatedId)
        .then(() => {
          this.$store.dispatch('alert/success', this.$t('individualReport.opetaion_init'))
          this.$store.dispatch('loading/hide')
          setTimeout(this.refreshPage, 3000)
        })
        .catch((err) => {
          if (err.code === 'suite-fail/evaluation/spend-fail') {
            this.noBalanceResponse = true
            this.disableButtonModal = true
            this.$store.dispatch('alert/error', this.$t('errors.no_balance'))
          } else {
            this.$store.dispatch('alert/error', this.$t(`errors.${err.code}`))
          }
          this.$store.dispatch('loading/hide')
          this.lockPdfButton = false
        })
    },
    refreshPage () {
      window.location.reload()
    }
  }
})
</script>
